// lib/daimon/models.ts
import type { DaimonModel } from '#types/types';
export const DAIMON_MODEL = 'gpt-realtime-2.1';
export const LEGACY_DAIMON_MODEL = 'gpt-realtime-1.5';
export type { DaimonModel } from '#types/types';
export const isDaimonModel = (value: unknown): value is DaimonModel => value === DAIMON_MODEL || value === LEGACY_DAIMON_MODEL;
